import { render, staticRenderFns } from "./Trendinganalysis.vue?vue&type=template&id=253bff78"
import script from "./Trendinganalysis.vue?vue&type=script&lang=js"
export * from "./Trendinganalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports